import React from 'react';

const LoadingSpinner = ({ translations }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        backgroundColor: "rgb(239 246 255)",
        minHeight: "100vh",
      }}
    >
      <div className="text-center">
        <div
          className="spinner-border text-primary"
          style={{ width: "3rem", height: "3rem" }}
        ></div>
        <p className="mt-3">{translations.verifyingToken}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;